import { sendUpdateMessage } from '../../websocket';
export function scenarioSpeedChange(scenarioSpeed) {
    return function (dispatch, getState) {
        dispatch(sendUpdateMessage('scenarioSpeed', scenarioSpeed));
    };
}
export function skipScenarioEvents(ms) {
    return sendUpdateMessage('scenarioSkip', ms);
}



//////////////////
// WEBPACK FOOTER
// ./src/components/VehicleController/actions.ts
// module id = 322
// module chunks = 0